import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Pricing from "../pages/pricing/page";
import Course from "../pages/course/page";
import Community from "../pages/community/page";
import Login from "../pages/login/page";
import Register from "../pages/register/page";
import Disclaimer from "../pages/disclaimer/page";
import AffiliateDisclosure from "../pages/affiliate-disclosure/page";
import KnowledgeHub from "../pages/knowledge-hub/page";
import Blog from "../pages/blog/page";
import ArticlePage from "../pages/blog/article/page";
import BlogAdmin from "../pages/blog/admin/page";
import BlogEdit from "../pages/blog/admin/edit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/course",
    element: <Course />,
  },
  {
    path: "/community",
    element: <Community />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/affiliate-disclosure",
    element: <AffiliateDisclosure />,
  },
  {
    path: "/knowledge-hub",
    element: <KnowledgeHub />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/admin",
    element: <BlogAdmin />,
  },
  {
    path: "/blog/admin/:id",
    element: <BlogEdit />,
  },
  {
    path: "/blog/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;